import { slice } from "lodash"
import { Table } from "vxe-table"
// import { summaryTableColumn } from "./tableColumn.js";
const list1 = ([
  {
    name: "今开",
    value: "30.06",
    color: "red",
    prop:'openPrice'
  },
  {
    name: "换手",
    value: "8.37%",
     prop:'turnoverRate'
  },

  {
    name: "成交量",
    value: "8.42万",
    prop:'turnoverVolume'
  },
  {
    name: "均价",
    value: "31.63",
    prop:'avgPrice'
  },
  {
    name: "成交额",
    value: "2.66亿",
    prop:'turnoverValue'
  },
  {
    name: "最高",
    value: "34:00",
    color: "red",
     prop:'highPrice'
  },
  
])
const list2=([ 
{
  name: "最低",
  value: "28.55",
  color: "red",
  prop:'lowPrice'
},{
  name: "振幅",
  value: "19.23%",
  prop:'rangePCT'
},
{
  name: "市盈率",
  value: "亏损",
  prop:'pe'
},
{
  name: "涨跌幅",
  value: "亏损",
  prop:'changePCT'
}, {
  name: "市净率",
  value: "4.84",
  prop:'pb'
},
{
  name: "市销率",
  value: "7.03",
  prop:'ps'
},]);
const list3 = ([
 
  
 
  {
    name: "昨收",
    value: "28.63",
    prop:'prevClosePrice'
  },
  {
    name: "总股本",
    value: "1.01亿",
    prop:'totalShares'
  },
  {
    name: "流通股",
    value: "1.01亿",
    prop:'rptAFloatListed'
  },
  {
    name: "ROA",
    value: "-4.15%",
    prop:'roa'
  },
  {
    name: "股息率",
    value: "--",
    prop:'dividendRatioLYR'
  },
  {
    name: "",
    value: "--",
    prop:''
  },
  {
    name: "",
    value: "--",
    prop:''
  },
  {
    name: "",
    value: "--",
    prop:''
  },
  
])
// export function stockInfo(data) {
//   console.log(data,'data')
//   let info = ''
//   list1.forEach((item) => {
//     let divLeft = ` <div style="  width: 110px; font-size:14px;  display: flex;  justify-content: space-between;   margin-right: 40px;" >`
//     let spanLeft = `<div style="color:#909399">${item.name}</div>`
//     let spanRight = `<div style="color:#000311;">${item.prop?(twodecimalPlaces(data[item.prop])||'--'):''}</div>`
//     let divRight = '</div>'
//     info += divLeft + spanLeft + spanRight + divRight

//   })
//   list2.forEach((item) => {
//     let divLeft = ` <div style="  width: 110px; font-size:14px; display: flex;  justify-content: space-between;   margin-right: 40px;" >`
//     let spanLeft = `<div style="color:#909399">${item.name}</div>`
//     let spanRight = `<div style="color:#000311;" >${item.prop?(twodecimalPlaces(data[item.prop])||'--'):''}</div>`
//     let divRight = '</div>'
//     info += divLeft + spanLeft + spanRight + divRight

//   })
//   return (`<div style="display: flex; justify-content: center;flex-wrap: wrap; width: 900px;margin-bottom:10px;">${info}</div>`)
// }
export function findByBlockTradeTable(data, column) {
  let tableTh = '';
  column.forEach((item) => {
    tableTh += `<th style="background-color:#fdf6ec;margin:0px;padding:0px;border:none;color:#727475;font-weight:500;width:${item.width||'100px'};"><span style="display: block;
    height: 100%;
    width: 100%;
    padding:5px 3px;
    border: 1px solid #ccc; border-left: 0px;">${item.label}</span></th>`
  })
  let bodyVal = '';
  data.forEach((item) => {
    let tdStr = '<tr>';
    column.forEach((elem) => {
      tdStr += `<td>${(elem.date && item[elem.prop]) ? item[elem.prop].slice(0, 10) : convertToWan(item[elem.prop],elem.isNmuber) || '--'}</td > `
    })
    bodyVal += tdStr + '</tr>'
  })
  let tableVal = `<div  style="max-height: 300px;border-left:1px solid #ccc; border-bottom:1px solid #ccc;margin:10px; overflow: auto;max-width:100%;"><table style="border-collapse: initial;margin:0px;table-layout: fixed;border-spacing: 0;width: 100%;position: relative;border-top:0px; border-left:0px;"><thead style="position: sticky; top: 0;"><tr> ${tableTh}</tr> </thead><tbody>${bodyVal}</tbody></table></div><br>`
  return tableVal
}
export function stockInfo(data) {
  console.log(data, 'data');
  let info = '';
  list1.forEach((item) => {
    let divLeft = `<span style="width: 110px; font-size: 14px; display: inline-block; vertical-align: top; margin-right: 40px; ">`;
    let spanLeft = `<span style="color:#909399; display: inline-block;float:left;">${item.name}</span>`;
    let spanRight = `<span style="color:#000311; display: inline-block;float:right;">${item.prop ? (twodecimalPlaces(data[item.prop]) || '--') : ''}</span>`;
    let divRight = '</span>';
    info += divLeft + spanLeft + spanRight + divRight;
  });
  info=`<div>${info}</div>`
  list2.forEach((item) => {
    let divLeft = `<span style="width: 110px; font-size: 14px; display: inline-block; vertical-align: top; margin-right: 40px;">`;
    let spanLeft = `<span style="color:#909399; display: inline-block;float:left;">${item.name}</span>`;
    let spanRight = `<span style="color:#000311; display: inline-block;float:right;">${item.prop ? (twodecimalPlaces(data[item.prop]) || '--') : ''}</span>`;
    let divRight = '</span>';
    info += divLeft + spanLeft + spanRight + divRight;
  });
 info=`<div>${info}</div>`
 list3.forEach((item) => {
  let divLeft = `<span style="width: 110px; font-size: 14px; display: inline-block; vertical-align: top; margin-right: 40px;">`;
  let spanLeft = `<span style="color:#909399; display: inline-block;float:left;">${item.name}</span>`;
  let spanRight = `<span style="color:#000311; display: inline-block;float:right;">${item.prop ? (twodecimalPlaces(data[item.prop]) || '--') : ''}</span>`;
  let divRight = '</span>';
  info += divLeft + spanLeft + spanRight + divRight;
});
info=`<div>${info}</div>`
  return `<div style="display: block; text-align: center; width: 900px; margin-bottom: 10px;">${info}</div>`;
}
export function summaryTable(data, summaryTableColumn, type) {

  let time = ''
  let header2 = `<th style="margin:0px;padding:0px;border:0px;background-color:#fdf6ec;color:#727475;font-weight:500;width:100px;"><span style="display: block;
    height: 100%;
    width: 100%;
    padding:5px 3px;
    border: 1px solid #ccc;border-top:0px;border-left:0px;">股票代码</span></th>`
  let body = ''
  let tableTh = '';
  let header3 = '';

  data.forEach((item) => {

    let first1 = ''
    time += `<th style="margin:0px;padding:0px;border:0px;background-color:#fdf6ec;color:#727475;font-weight:500;" colspan=${item.list.length}><span style="display: block;
    height: 100%;
    width: 100%;
    padding:5px 3px;
    border: 1px solid #ccc;border-left:0px;border-bottom:0px;">${item.quarter}</span></th>`
    item.list.forEach((elem) => {
      header2 += `<th style="margin:0px;padding:0px;border:0px;background-color:#fdf6ec;color:#727475;font-weight:500"><span style="display: block;
    height: 100%;
    width: 100%;
    padding:5px 3px;
    border: 1px solid #ccc;border-left:0px;">${elem.stock}</span></th>`
    })

  })
  let newarr = []
  summaryTableColumn.forEach((coloum) => {
    coloum.list.forEach((col, index) => {
      let b = ''
      if (index == 0) {
        b = `<td >${col.name}</td>`
        data.forEach((item) => {
          item.list.forEach((list) => {
            if (type) {
              list = { stock: list.stock, ...list.entity }
            }
            b += `<td>${convertToWan(list[col.value]) || '--'}</td>`
          })
        })
        if (coloum.title) {
          body += `<tr><td style="text-align:center; writing-mode: vertical-rl;text-orientation: mixed;width:30px; background:#fdf6ec;color:rgb(114, 116, 117)" rowspan="${coloum.list.length}">${coloum.title}</td>${b}</tr>`
        }
      } else {
        b = `<td style="color:rgb(114, 116, 117)">${col.name}</td>`
        data.forEach((item) => {
          item.list.forEach((list) => {
            if (type) {
              list = { stock: list.stock, ...list.entity }
            }
            b += `<td>${convertToWan(list[col.value]) || '--'}</td>`
          })
        })
        body += `<tr>${b}</tr>`
      }
    })

  })
  let td1 = type == 2 ? '' : `<th  rowspan="2" style="margin:0px;padding:0px;border:0px;background-color:#fdf6ec;color:#727475;font-weight:500;width:30px;"><span style=" height: 100%;
    width: 100%;
    display: block;
    padding:5px 3px;
    border: 1px solid #ccc;">类型</span></th>`
  let headers = `<tr class="header">
 ${td1}
  <th rowspan="1" style="margin:0px;padding:0px;border:0px;background-color:#fdf6ec;color:#727475;font-weight:500;width:100px;"><span style="display: block;
    height: 100%;
    width: 100%;
    padding:5px 3px;
    border: 1px solid #ccc;border-left:0px;">时间</span></th>
${time}
</tr>`
  return `<div style="max-height: 300px;border-left:1px solid #ccc;  border-bottom:1px solid #ccc; margin:10px; overflow: auto;max-width:100%;"><table style="border-collapse: initial;margin:0px;table-layout: fixed;border-spacing: 0;width: 100%;position: relative;border-top:0px;border-left:0px;"><thead style="position: sticky; top: 0;">${headers}<tr>${header2}</tr></thead><tbody >${body}</tbody></table></div><br>`

}

export function convertToWan(num,isNmuber) {
  
  // 判断是否为数字
  if (typeof num !== 'number' || isNaN(num)||isNmuber) {
    return num;
  }

  // 判断是否大于等于1万
  if (Math.abs(num) >= 10000) {
    let result = (num / 10000).toFixed(2); // 先保留两位小数
    if (result.endsWith(".00")) { // 如果小数部分为00
      result = result.slice(0, -3); // 去掉小数部分
    }
    return result + "万";
  } else {
    let numFixed=num.toFixed(2)
    if (numFixed.endsWith(".00")) { // 如果小数部分为00
      numFixed = numFixed.slice(0, -3); // 去掉小数部分
    }
    return numFixed; // 小于1万，直接返回原数字
  }
}

export function twodecimalPlaces(num){
    // 判断是否为数字
    if (typeof num !== 'number' || isNaN(num)) {
      return num;
    }
    let numFixed=num.toFixed(2)
    if (numFixed.endsWith(".00")) { // 如果小数部分为00
      numFixed = numFixed.slice(0, -3); // 去掉小数部分
    }
    return numFixed; 
  
}